class ProductNew {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(".js-tab-content").hide();
    $(".js-product-tab").removeClass("is-active");
  
    var hash = window.location.hash;
  
    if (hash) {
      var $targetContent = $(hash);
      if ($targetContent.length) {
        $targetContent.show();
        var index = $targetContent.index(".js-tab-content");
        $(".js-product-tab").eq(index).addClass("is-active");
      } else {
        $(".js-tab-content:first").show();
        $(".js-product-tab:first").addClass("is-active");
      }
    } else {
      $(".js-tab-content:first").show();
      $(".js-product-tab:first").addClass("is-active");
    }
  
    $(".js-product-tab").click(function () {
      $(".js-tab-content").hide();
      var index = $(this).index();
      $(".js-tab-content").eq(index).show();
  
      $(".js-product-tab").removeClass("is-active");
      $(this).addClass("is-active");
    });
    
  }
}
